import { get, post } from "../config/api/user";

export const Gateway = {
  create: ({ name }: { name: string }) => post(`gateway`, { name }),
  get: () => get(`gateway/self`),
};
